import React from "react";
import axios from 'axios'
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import $ from 'jquery'; 
import './machinedetails.css';
 
class MachineDetails extends React.Component {
	state = {
        dataset: [],
		dataset2:[]
    };

	componentDidMount(props)
   {
	this.getPostDetails();	
 }
getPostDetails = (props) => {
	let id = this.props.id;
	fetch(`http://localhost:8090/api/orders/${id}`)
        .then((response) => response.json())
        .then(data => {
            this.setState({ dataset: data });
        });
		fetch('http://localhost:8090/api/orders/')
        .then((response) => response.json())
        .then(data => {
            this.setState({ dataset2: data });
        });
};
gettable=(e)=>{
	document.getElementById("showhidetoggle").style.display = "block";
	$(document).ready(function () {
		$(document).on('click','#example tbody tr',function(){
			var subgroupcode=$(this).find('td:eq(0)').text();
			var macgroup=$(this).find('td:eq(1)').text();
			var description=$(this).find('td:eq(2)').text();
			$('#subgroupcode').val(subgroupcode);
			$('#macgroup').val(macgroup);
			$('#description').val(description);
		})
	});
	this.loadjquery();
}
loadjquery=(e)=>{
	$(document).ready(function () {
		$('#example').DataTable();
	});
}
// autosuggetsdata=(e)=>{
// 	let filterval=document.getElementById("subgroupcode").value.toUpperCase();
// 	let mytable=document.getElementById("example");
// 	let tr=mytable.getElementsByTagName('tr');
// 	for(var i=0;i<tr.length;i++){
// 		let td=tr[i].getElementsByTagName('td')[0];
// 		if(td){
// 			let textval=td.textContent || td.innerHTML;
// 			if(textval.toUpperCase().indexOf(filterval)>-1){
// 				tr[i].style.display="";
// 			}
// 			else{
// 				tr[i].style.display="none";
// 			}
// 		}
// 	}

// }

  changeHandler=(e)=>{
this.setState({[e.target.name]:e.target.value})
  }
  rowSelected = (e) =>{
	document.getElementById("showhidetoggle").style.display = "none";
  }
 submitHandler = e =>{
	 e.preventDefault()
	 let element = document.getElementById("showhidetoggle");
	 let styleval = element.style.display;
	 if(styleval==='none'){
		axios.post('https://jsonplaceholder.typicode.com/posts',this.state)
		.then(response => console.log(response))
		.then(response => alert("Data send Successfully....!"))
		.catch(error => {console.log(error)})
	 }
	 else{
		 alert("close table first ....!")
	 }
 }
 
	render(){
		const {userId,title,body}=this.state		
  return (
    <div>
	<div className="row">
{this.state.dataset.map((machine,i) => (
	<div key={i} className="col-sm-12">
		<div className="card">
			<div className="card-header">
				<h5 id="md">Machine Details</h5>
			</div>
			<div className="card-body">
				<form id="validation-form123" onSubmit={this.submitHandler}>
					<div className="row">
						<div className="col-md-6">
							<div className="form-group">
								<label className="form-label">Name</label>
									<input type="text" className="form-control" name="title" value={title} onChange={this.changeHandler} defaultValue={machine.MACHINE_NAME} />
							</div>
						</div>
						<div className="col-md-6">
	<div className="form-group">
	<label className="form-label mx-2">Critical / Non Critical </label>
	<div className="custom-control custom-switch">{machine.CRITICAL}
  <input type="checkbox" className="custom-control-input" id="customSwitch1" />
  <label className="custom-control-label" htmlFor="customSwitch1"></label>
</div>
	</div>
	</div>
	<div className="col-md-6">
	<div className="form-group">
	<label className="form-label">Downtime Factor</label>
	<input type="number" className="form-control" name="userId" value={userId} onChange={this.changeHandler} defaultValue={machine.DownTimeFactor}  />
	</div>
	</div>
	<div className="col-md-6">
	<div className="form-group">
	<label className="form-label">Subgroup Code</label>
	<input type="text" list="subgroup" id="subgroupcode" onClick={this.gettable} className="form-control" name="body" value={body} onChange={this.changeHandler} defaultValue={machine.MSUBGROUP_CODE}/>
	<input type="text" className="form-control hiddeninput" id="macgroup" />
	<input type="text" className="form-control hiddeninput" id="description" />
	{/* <datalist id="subgroup">
	{this.state.dataset2.map((machine2) => (
<option value={machine2.MSUBGROUP_CODE}></option>
))}
	</datalist> */}
	</div>
	</div>
	<div className="col-md-12" id="showhidetoggle">
	<table id="example" className="table table-bordered table-hover">
		<thead>
			<tr>
				<td>
				MSUBGROUP_CODE
				</td>
				<td>
				MACGROUP_CODE
				</td>
				<td>
				DESCRIPTION
				</td>
			</tr>
		</thead>
		<tbody>
		{this.state.dataset2.map((machine2,i) => (
			<tr key={i} onClick={this.rowSelected}>
				<td>
				{machine2.MSUBGROUP_CODE}
				</td>
				<td>
				{machine2.MACGROUP_CODE}
				</td>
				<td>
				{machine2.USAGE}
				</td>
			</tr>
			))}
		</tbody>
	</table>
	</div>
	<div className="col-md-6">
	<div className="form-group">
	<label className="form-label">Machine Type</label>
	<select className="form-control">
	<option>{machine.MACHINE_TYPE}</option>
	</select>
	</div>
	</div>
	<div className="col-md-6">
	<div className="form-group">
	<label className="form-label">Cost Center</label>
	<input type="text" className="form-control" name="validation-phone" placeholder="-" readOnly />
	</div>
	</div>
	<div className="col-md-6">
	<div className="form-group">
	<label className="form-label">% of cost center rate as down time</label>
	<input type="text" className="form-control" defaultValue={machine.PerDownTimeCost} />
	</div>
	</div>
	<div className="col-md-6">
	<div className="form-group">
	 <label className="form-label">Machine Usage</label>
	<input type="text" className="form-control" name="validation-text" defaultValue={machine.USAGE} />
	</div>
	</div>
	<div className="col-md-6">
	<div className="form-group">
	<label className="form-label">Location</label>
	<input type="text" className="form-control" name="validation-text" defaultValue={machine.LOCATION} />
	</div>
	</div>
	<div className="col-md-6">
	<div className="form-group">
	<label className="form-label">Station</label>
	<input type="text" className="form-control" />
	</div>
	</div>
	<div className="col-md-6">
	<div className="form-group">
	<label className="form-label">Machine Specification</label>
	<input type="text" className="form-control" name="validation-text" defaultValue={machine.SPEC1} />
	<input type="text" className="form-control" name="validation-text" defaultValue={machine.SPEC2} />
	<input type="text" className="form-control" name="validation-text" defaultValue={machine.SPEC3} />
	</div>
	</div>
	<div className="col-md-6">
	<div className="form-group">
	<label className="form-label">Safety Measure</label>
	<input type="text" className="form-control" name="validation-text" defaultValue={machine.SAFETY_MEAS1} />
	<input type="text" className="form-control" name="validation-text" defaultValue={machine.SAFETY_MEAS2} />
	<input type="text" className="form-control" name="validation-text" defaultValue={machine.SAFETY_MEAS3} />
	</div>
	</div>
	<div className="col-md-4">
	<div className="form-group">
	<label>warranty From</label>
	<input type="date" className="form-control" defaultValue={machine.WARRANTY_FROM_DATE}/>
	</div>
	</div>
	<div className="col-md-4">
	<div className="form-group">
	<label>To</label>
	<input type="date" className="form-control" defaultValue={machine.WARRANTY_TO_DATE} />
	</div>
	</div>
	<div className="col-md-4">
	<div className="form-group">
	<label>Contract Expiry Date</label>
	<input type="date" className="form-control" defaultValue={machine.AMC_EXPIRY_DATE} />
	</div>
	</div>
	<div className="col-md-6">
	<div className="form-group">
	<label className="form-label">contract to</label>
	<input type="text" className="form-control" defaultValue={machine.CONTRACT_TO} />
	</div>
	</div>
	<div className="col-md-6">
	<div className="form-group">
	<label className="form-label"></label>
	<div className="form-check">{machine.UtilityEquipment}
	<div className="custom-control custom-checkbox">
	<input type="checkbox" className="custom-control-input" id="customCheck1"/>
	<label className="custom-control-label" htmlFor="customCheck1">Utility Equipment</label>
	</div>
	</div>
	<div className="form-check">
	<div className="custom-control custom-checkbox">{machine.ACTIVE_INACTIVE}
	<input type="checkbox" className="custom-control-input" id="customCheck2"/>
	<label className="custom-control-label" htmlFor="customCheck2">Machine Active</label>
	</div>
	</div>
	</div>
	</div>
	<div className="col-md-6">
	<div className="form-group">
	<label className="form-label">Deactive Date</label>
	<input type="date" className="form-control" defaultValue={machine.MACHINE_DEACTIVATION_DATE} />
	</div>
	</div>
	<div className="col-md-6">
	<div className="form-group">
	<label className="form-label">Resposibility</label>
	<input type="text" className="form-control" defaultValue={machine.RESPONSIBILITY} />
	</div>
	</div>

	</div>
	<button type="submit" className="btn  btn-primary">Submit</button>
	</form>
	</div>
	</div>
	</div>
))}
	</div>
    </div>
  );
	}
}

export default MachineDetails;